<template>
    <div class="">
        <div class="float-right">
            <q-btn outline class="" v-if="ShowRemoveButton" label="Remove" style="color: #ff6666;" @click="RemoveButton()" :disable="DisableRemoveButton"/>
            <q-btn icon="create" v-if="ShowEditButton" color="primary" text-color="white" @click="EditButton()" :disable="DisableEditButton"/>
        </div>
    </div>
</template>

<script>
import store from '../store'; // only use for calling states
import { mapActions } from "vuex"; // only use for calling actions
export default {
    props: [
        'ShowEditButton',
        'DisableEditButton',
        'ShowRemoveButton',
        'DisableRemoveButton',
    ],
    components: {
    },
    data() {
        return {
        
        }
    },
    methods : {
        EditButton(){
            this.$emit('EditButton')
        },
        RemoveButton(){
            this.$emit('RemoveButton')
        },
    },
    mounted(){
        
    }
}
</script>
        